<template>
    <div>
        <!-- 虚拟桌面 -->
        <div class="workspace">
            <Row :gutter="10">
                <Col span="4" style="padding-left:10px">
                    <Select v-model="accountType" filterable :placeholder="$t('permission_configuration_management.group.checkByAccountType')"  @on-change="searchAccountType()" :transfer="true">
                        <Option value="" selected>{{$t('alarms.common.all')}}</Option>
                        <Option :value="item.id" v-for="item in accountTypeList" :key="item.name">{{item.name}}</Option>
                    </Select>
                </Col>
                <Col span="4">
                    <Input search v-model="accountName" :placeholder="$t('permission_configuration_management.group.checkByAccountName')" @on-search="searchAccountName()"/>
                </Col>
                <Col span="4">
                    <Input search v-model="workspaceId" :placeholder="$t('permission_configuration_management.group.checkByVirtualDesktopID')" @on-search="searchWorkspaceId()"/>
                </Col>
                <Col span="4">
                    <Input search v-model="privateIp" :placeholder="$t('permission_configuration_management.group.checkByPrivateIP')" @on-search="searchPrivateIp()"/>
                </Col>
                <Col span="4">
                    <Button type="primary" @click="modal = true" v-hasPermission="['permissionsConfigurationManagement:resourcePermission:add_virtual_desktop']">{{$t('permission_configuration_management.group.addVirtualDesktop')}}</Button>
                </Col>
            </Row>
        </div>
        <Modal v-model="modal" :title="$t('permission_configuration_management.group.addVirtualDesktop')" width="900px;" :loading="modalLoading" :ok-text="$t('alarms.common.add')" :mask-closable="false" :closable="false">
            <Form :model="workSpaceForm" :label-width="100" ref="workSpaceForm" :rules="ruleValidate">
                <!-- 搜索 -->
                <Row :gutter="16">
                    <Col span="8">
                        <!-- 账户 -->
                        <FormItem :label="$t('permission_configuration_management.group.name')" prop="account" :label-width="50">
                            <Select v-model="workSpaceForm.account"
                                @on-change="changeAccount(workSpaceForm.account)" :transfer="true"
                                    :placeholder="$t('permission_configuration_management.common.pleaseSelect')">
                                <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="8" style="z-index: 200">
                        <!-- 存储区域 -->
                        <FormItem :label="$t('permission_configuration_management.group.region')" prop="region" :label-width="70">
                            <Select @on-change="changeRegion(workSpaceForm.region)"
                                v-model="workSpaceForm.region" :transfer="true"
                                    :placeholder="$t('permission_configuration_management.common.pleaseSelect')">
                                <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Button type="primary" style="float:right;" v-show="isShowSearch" @click="searchWorkSpaceInput()">{{ $t('alarms.common.search') }}</Button>
                </Row>
            </Form>
            <div slot="footer">
                <Button @click="cancel('workSpaceForm')">{{$t('permission_configuration_management.common.cancel')}}</Button>
                <Button type="primary" @click="handleSubmit('workSpaceForm')" :loading="addloading" :disabled="isDisable">{{$t('permission_configuration_management.common.confirm')}}</Button>
            </div>
            <Table :no-data-text="$t('common.noData')" ref="selection" :columns="columns" :loading="loading" :data="queryWorkSpaceData" :height="400" @on-selection-change="getSelection"></Table>
        </Modal>
        <table-work-space ref="tableWorkSpaceChild"></table-work-space>
    </div>
</template>

<script>
    import {getCookie} from '../../../../utils/cookieUtil.js'
    import {CLOUD_PLATFORM_ID, buildPlatformOptions} from '../../../../utils/cloudPlatform.js'
    import TableWorkSpace from '../resource_permission/TableWorkSpace'

    var tableWorkSpace = TableWorkSpace;
    export default {
        name: 'AddWorkSpace',
        components: {
            TableWorkSpace
        },
        data() {
            return {
                accountType: '',
                accountName: '',
                workspaceId:'',
                privateIp:'',
                selection: [],
                accountTypeList: buildPlatformOptions([
                    CLOUD_PLATFORM_ID.AWS,
                    CLOUD_PLATFORM_ID.ALIYUN,
                    CLOUD_PLATFORM_ID.AZURE
                ]),
                modal: false,
                modalLoading: true,
                loading: false,
                addloading:false,
                isDisable: true,
                accountList: [],
                regionList: [],
                isShowSearch: false,
                workSpaceForm: {
                    account: '',
                    region: ''
                },
                ruleValidate: {
                    account: [
                        {required: true, message: this.$t('permission_configuration_management.resourcePermission.pleaseSelectAccountName'), trigger: 'change', type: 'number'}
                    ],
                    region: [
                        {required: true, message: this.$t('permission_configuration_management.resourcePermission.pleaseSelectStorageRegion'), trigger: 'change'}
                    ]
                },
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: this.$t('permission_configuration_management.group.name'),
                        key: 'name',
                        width: '120px'
                    },
                    {
                        title: this.$t('permission_configuration_management.group.virtualDesktopID'),
                        key: 'workspaceId'
                    },
                    {
                        title: this.$t('permission_configuration_management.group.privateIP'),
                        key: 'privateIp'
                    },
                    {
                        title: this.$t('alarms.common.status'),
                        key: 'stateName'
                    }
                ],
                queryWorkSpaceData: [],
                newQueryWorkSpaceDataList:[]
            }
        },
        methods: {
            // 按账户类型筛选
            searchAccountType: function(){
                eventBus.$emit('accountType', this.accountType);
                tableWorkSpace.methods.showAllWorkSpace();
            },
            // 按账户名称筛选
            searchAccountName: function(){
                eventBus.$emit('accountName', this.accountName);
                tableWorkSpace.methods.showAllWorkSpace();
            },
            // 按虚拟桌面ID搜索
            searchWorkspaceId: function(){
                eventBus.$emit('workspaceId', this.workspaceId);
                tableWorkSpace.methods.showAllWorkSpace();
            },
            // 按私有IP搜索
            searchPrivateIp: function(){
                eventBus.$emit('privateIp', this.privateIp);
                tableWorkSpace.methods.showAllWorkSpace();
            },
            // 父组件调用子组件table内的方法
            queryWorkspacesByGroupId(){
                this.$refs.tableWorkSpaceChild.queryWorkspacesByGroupId();
            },
            // 查询账户
            selectAccount: function () {
                this.$api.groupAccountRelation.getAccountsByGroupId("groupId", this.$route.query.id)
                    .then(res => {
                        this.accountList = res.data;
                        for (var i = 0; i < this.accountList.length; i++) {
                            this.accountList[i].name = this.accountList[i].name + '(' + this.accountList[i].accountTypeName + ')';
                        }
                    })
            },
            // 切换账户
            changeAccount: function () {
                if (this.workSpaceForm.account == "" || this.workSpaceForm.account == null) {
                    return;
                }
                this.workSpaceForm.region = '';
                this.isShowSearch = true;
                this.$api.account.queryAccountRegions("accountId", this.workSpaceForm.account)
                    .then(res => {
                        this.regionList = res.data;
                    })
            },
            // 切换存储区域
            changeRegion: function () {
                this.instanceList = [];
                this.isShowSearch = true;
            },
            // 当前选择checkbox
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.newQueryWorkSpaceDataList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    var TableQueryWorkSpaceDataCopy = new Object();
                    TableQueryWorkSpaceDataCopy.workspaceId = this.selection[i].workspaceId;
                    TableQueryWorkSpaceDataCopy.name = this.selection[i].name;
                    TableQueryWorkSpaceDataCopy.privateIp = this.selection[i].privateIp;
                    TableQueryWorkSpaceDataCopy.state = this.selection[i].state;
                    TableQueryWorkSpaceDataCopy.region = this.selection[i].region;
                    TableQueryWorkSpaceDataCopy.accountId = this.selection[i].accountId;
                    this.newQueryWorkSpaceDataList.push(TableQueryWorkSpaceDataCopy);
                }

                // 选了数据 可以点击下一步
                if (this.newQueryWorkSpaceDataList.length == 0) {
                    this.isDisable = true;
                } else {
                    this.isDisable = false;
                }
            },
            // 点击查询
            searchWorkSpaceInput: function () {
                if (this.workSpaceForm.account == "" || this.workSpaceForm.account == null || this.workSpaceForm.region == "" || this.workSpaceForm.region == null) {
                    return;
                }
                this.loading = true;
                // 根据AccountId查询workspace列表
                this.$api.workspace.queryWorkspaceByAccountId({
                    "region": this.workSpaceForm.region,
                    "accountId": this.workSpaceForm.account,
                    "groupId": this.$route.query.id
                }).then(res => {
                    this.queryWorkSpaceData = res.data.workspaceDTOS;
                    this.loading = false;
                })
            },
            // 添加
            handleSubmit: function (name) {
                this.$refs[name].validate(valid => {
                    if(valid){
                        // 增加instance
                        this.addloading=true;
                        this.$api.groupWorkspaceRelation.createGroupWorkspaceRelation({
                            "groupId": this.$route.query.id,
                            "workspaceDTOS":this.newQueryWorkSpaceDataList
                        }).then(res => {
                            setTimeout(() => {
                                tableWorkSpace.methods.showAllWorkSpace();
                                this.$refs[name].resetFields();
                                this.modalLoading = false;
                                this.$nextTick(() => {
                                    this.modalLoading = true;
                                });
                                this.$Message.success(this.$t('common.addSuccess'));
                                this.queryWorkSpaceData=[];
                                this.newQueryWorkSpaceDataList=[];
                                this.modal = false;
                                this.addloading=false;
                                this.isDisable = true;
                            }, 1000);
                        })
                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.modalLoading = false;
                        setTimeout(() => {
                            this.modalLoading = true
                        }, 0)
                        this.$Message.error(this.$t('common.addFail'));
                    }
                });

            },
             // 取消
            cancel: function (name) {
                this.isDisable = true;
                this.modal = false;
                this.loading = false;
                this.queryWorkSpaceData=[];
                this.newQueryWorkSpaceDataList=[];
                this.$refs[name].resetFields();
            }
        }
    }
</script>

<style scoped>
  .workspace {
    width: 100%;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/AddWorkSpace.vue